// extracted by mini-css-extract-plugin
export default {"block":"Bq0hNPKpAXDLUGSlCkxM","container":"deShPt4z0n_Eg2fpXtsn"};